module.exports = __webpack_public_path__ + "static/img/Honor of Kings.2943e8ac.png";